module.exports = __webpack_public_path__ + "static/media/ApplepieLogo.30013424.svg";